import { render, staticRenderFns } from "./StepOneMiscBottom.vue?vue&type=template&id=27c281a8"
import script from "./StepOneMiscBottom.vue?vue&type=script&lang=js"
export * from "./StepOneMiscBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports